<template>
  <div id="container" class="cs_st apply_st grid-container">
    <Sidebar />
    <BaseLocation current-group-name="onlyTeacher" />
    <div class="section">
      <div class="inner">
        <div class="box_wrap">
          <div class="box tac">
            <div ref="focus" class="box_title">
              <h2>증정 코드 입력</h2>
              <p class="guide_txt">증정 받으실 도서 코드를 입력해주세요.</p>
            </div>
            <div class="apply_formlist">
              <ul class="form_wrap">
                <li>
                  <p class="subtitle base_NM24 necessary">
                    <span class="point_txt">※</span>증정본 코드
                  </p>
                  <input
                    v-model.trim="couponNo"
                    type="text"
                    placeholder="0000-0000-0000-0000"
                    class="input_t"
                    maxlength="19"
                    @input="handleCouponInput"
                  />
                </li>
                <li>
                  <p class="subtitle base_NM24">
                    · 강의 학부<span class="base_NM16">(학과)</span>
                  </p>
                  <input
                    v-model="division"
                    type="text"
                    placeholder=""
                    class="input_t"
                    maxlength="20"
                  />
                </li>
                <li>
                  <p class="subtitle base_NM24">· 강의 학기</p>
                  <input
                    id="authorName"
                    v-model="semester"
                    type="text"
                    placeholder=""
                    class="input_t"
                    maxlength="20"
                  />
                </li>
                <li class="flex-center">
                  <p class="subtitle base_NM24">· 강의 학교</p>
                  <div class="btn_wrap">
                    <button
                      class="box_btn dull base_NM24"
                      @click="openSearchSchool"
                    >
                      대학교 선택
                    </button>
                    <input
                      v-model="unicolNm"
                      type="text"
                      placeholder="강의학교를 선택해주세요."
                      class="input_t"
                      readonly
                      @click="openSearchSchool"
                    />
                  </div>
                </li>
                <!-- <li class="mt_12">
                  <p class="subtitle base_NM24"></p>
                  <span class="base_NR18">
                    ※ 소속 검색이 되지 않을 시 ‘기타’ 선택 후 ‘기타 전하실 말’에
                    소속을 작성해주세요
                  </span>
                </li> -->
                <li>
                  <p class="subtitle base_NM24">· 강의명</p>
                  <input
                    v-model="classNm"
                    type="text"
                    placeholder=""
                    class="input_t"
                    maxlength="20"
                  />
                </li>
                <!-- <li>
                  <p class="subtitle base_NM24">수강 학생 수</p>
                  <input
                    v-model="enrolledCount"
                    maxlength="5"
                    onkeypress="if(this.value.length==5) return false;"
                    type="number"
                    placeholder="숫자입력"
                    class="input_t"
                    @change="validLength(5)"
                  />
                </li> -->
                <!-- <li class="before_wrap">
                  <p class="subtitle base_NM24 t_20">
                    · 이전 사용 교재명
                  </p>
                  <div class="input_t_wrap">
                    <input
                      v-model="textbookNm"
                      type="text"
                      placeholder="이전 도서명을 입력해주세요."
                      class="input_t"
                      maxlength="20"
                    />
                  </div>
                </li>
                <li class="before_wrap">
                  <p class="subtitle base_NM24 t_20">
                    · 이전 사용 출판사명
                  </p>
                  <div class="input_t_wrap">
                    <input
                      v-model="publisherNm"
                      type="text"
                      placeholder="이전 출판사명을 입력해주세요."
                      class="input_t"
                      maxlength="20"
                    />
                  </div>
                </li> -->
                <li>
                  <p class="subtitle base_NM24">· 기타 전하실 말</p>
                  <input
                    v-model="remark"
                    type="text"
                    placeholder="학교가 검색되지 않으시다면 해당칸에 소속을 작성해 주세요."
                    class="input_t"
                    maxlength="200"
                  />
                </li>
              </ul>
            </div>
            <div class="btn_wrap">
              <button class="book_receive" @click="requestPresent">
                증정도서 받기
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <!-- ERROR MODAL START -->

    <transition name="modal-fade">
      <unicolModal
        v-if="showUnicolsModal"
        @close="showUnicolsModal = false"
        @unicolInfo="selectUnicol"
      />
    </transition>
    <transition name="modal-fade">
      <Modal v-if="showErrorModal">
        <div
          v-on-clickaway="isErrors ? closeModal : returnRoute"
          class="ly_pop_wrap"
        >
          <div class="ly_pop_content ly_pop_msg ly_txt ly_alert">
            <div class="ly_inner">
              <p>
                {{ modalMsg }}
              </p>
              <p>
                {{ modalSubMsg }}
              </p>
              <div v-if="isErrors" class="btnWrap">
                <button class="box_btn" @click="closeModal">
                  <span class="an_t">확인</span>
                </button>
              </div>
              <div v-else class="btnWrap">
                <button class="box_btn wt" @click="returnRoute">
                  <span class="an_t">확인</span>
                </button>
                <button
                  v-if="!modalMsg.includes('교강사 전용 페이지입니다.')"
                  class="box_btn"
                  @click="toLibrary"
                >
                  <span class="an_t">내 서재 바로가기</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </transition>
    <!-- ERROR MODAL END -->
  </div>
</template>
<script>
import unicolModal from '@/components/library/unicolModal.vue'
export default {
  name: 'PostPresent',
  components: {
    unicolModal
  },
  data() {
    return {
      isErrors: false,
      searchTxt: '',
      modalMsg: '',
      modalSubMsg: '',
      modalTitleTxt: '',
      currentPage: 1,
      applyPerPage: 10,
      isShowModal: false,
      showErrorModal: false,
      showUnicolsModal: false,
      inOnModal: false,
      classNm: '',
      semester: '',
      textbookNm: '',
      unicolCd: '',
      publisherNm: '',
      couponNo: '',
      division: '',
      enrolledCount: '',
      remark: '',
      unicolNm: ''
    }
  },
  computed: {
    isChkValid() {
      if (!this.couponNo) {
        return false
      }
      return true
    }
  },
  mounted() {
    if (this.$store.getters.getCurrentUser?.memberTp !== '2000') {
      // this.isErrors = false
      this.toggleErrorModal(`교강사 전용 페이지입니다.`, '', false)
    }
  },
  methods: {
    validLength(mxLength) {
      if (this.enrolledCount > mxLength) {
        this.enrolledCount = Number(String(this.enrolledCount).substr(0, 5))
      }
    },
    openSearchSchool() {
      this.showUnicolsModal = true
    },
    selectUnicol(unicol) {
      this.unicolCd = unicol.unicolCd
      this.unicolNm = unicol.unicolNm
      this.showUnicolsModal = false
    },
    async requestPresent() {
      if (!this.isChkValid) {
        this.toggleErrorModal('필수항목을 모두 입력해주세요.', '', true)
        return
      }
      try {
        const {
          classNm,
          semester,
          textbookNm,
          publisherNm,
          couponNo,
          division,
          enrolledCount,
          unicolCd,
          remark
        } = this
        await this.$store.dispatch('requestPresentBook', {
          classNm,
          semester,
          textbookNm,
          publisherNm,
          couponNo,
          division,
          enrolledCount,
          remark,
          unicolCd
        })
        this.toggleErrorModal(
          // `증정본 지급이 완료 되었습니다 내 서재에서 바로 이용이 가능합니다.`,
          '증정본 지급이 완료 되었습니다.',
          '내 서재 → 상단 증정도서 서재에서 바로 이용이 가능합니다.',
          false
        )
      } catch (err) {
        let message = err.response.data.errorState.message
        let subMsg = ''
        let error = true
        if (err.response.data.errorState.reason === '사용 완료') {
          subMsg = '내 서재 → 증정도서 책장을 확인해 주세요.'
          error = false
        }
        this.toggleErrorModal(message, subMsg, error)
      }
    },
    closeModal() {
      this.showErrorModal = false
    },
    returnRoute() {
      this.closeModal()
      this.$router.push({
        name: 'store'
      })
    },
    toLibrary() {
      this.closeModal()
      this.$router.push({
        name: 'library_default'
      })
    },
    toggleErrorModal(msg, subMsg, isErr) {
      this.modalMsg = msg || '필수항목을 모두 입력해주세요.'
      this.modalSubMsg = subMsg
      this.isErrors = isErr
      this.showErrorModal = !this.showErrorModal
    },
    closeUnicolsModal() {
      this.showUnicolsModal = false
    },
    handleCouponInput(event) {
      // first parmas: 사용자가 타입할때 들어오는 값
      // second parmas: 타입 시점의 cardNumber 전체 값
      this.couponNo = this.couponFormatter(event.data, event.target.value)
    },
    couponFormatter(value, couponNo) {
      couponNo = couponNo.trim()
      let result = ''

      // 0-9까지의 숫자와 하이픈(-) 값 체크
      let check01 = /[^A-Za-z0-9-]/g

      // 하이픈 값 체크
      let check02 = /[-]/g

      if (check01.test(couponNo) || check02.test(value)) {
        result = couponNo
        // result = couponNo
      } else {
        // 0000-0000-0000-0000 형식이 되도록 숫자 4자리가 들어오면
        // 하이픈을 자동으로 넣어준다
        result = couponNo.match(/[A-Za-z0-9]{1,4}/g)?.join('-') || couponNo
      }

      return result
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/_variables.scss';
.section {
  background-color: #eff3f9;
  .inner {
    margin-top: 52px;
    margin-bottom: 50px;
    padding: 37px 0;
    background-color: #fff;
    border-radius: 35px;
    max-width: 715px;
  }
}
.input_t_wrap {
  display: grid;
  // grid-template-columns: 1fr 1fr;
  gap: 0px 12px;
}
.t_20 {
  top: 20% !important;
}
// 학지추가
// .section .inner {
//   padding: 132px 0 124px;
// }
.apply_st .box_wrap {
  margin: 0 auto;
}
.apply_st .box_wrap,
.apply_st .box_wrap .box {
  width: 100%;
  max-width: 600px;
}
.guide_txt {
  margin-top: 10px;
  font-size: 18px;
  line-height: 30px;
  color: #767777;
}
.apply_formlist {
  text-align: left;
  margin-bottom: 20px;
  .form_wrap {
    margin-top: 40px;
    li {
      display: flex;
      align-items: center;
      p {
        flex: 1 0 auto;
        max-width: 150px;
        min-width: 150px;
        font-weight: 500;
        font-size: 18px;
        letter-spacing: 0.1px;
      }
      .necessary {
        color: #e95d5d;
        font-size: 24px;
      }
      + .mt_12 {
        margin-top: 8px;
        color: $h_BLUE_01;
        span {
          line-height: 1.2em;
        }
      }
      .box_btn {
        height: 100%;
        margin-right: 7px;
        padding: 10px 40px 10px;
        background: #008df3;
        border-radius: 6px;
        white-space: nowrap;
        line-height: 17px;
        font-size: 17px;
        color: #fff;
      }
      input {
        flex: 1;
        padding: 0 15px;
        border-radius: 7px;
        border: 1px solid #d3dcf0;
        line-height: 37px;
        &::placeholder {
          color: #c6c6c6;
        }
      }
      .btn_wrap {
        display: flex;
        flex: 1;
      }
    }
    .before_wrap {
      .input_t_wrap {
        width: 100%;
      }
    }
  }
}
.box_wrap {
  .box {
    .box_title {
      h2 {
        margin-top: 0;
        letter-spacing: 0.1px;
        font-size: 29px;
        color: #000;
      }
    }
  }
  .btn_wrap {
    .box_btn {
      .an_t {
        font-size: 24px;
      }
    }
  }
}

.book_receive {
  margin-top: 20px;
  padding: 14px 42px;
  background-color: #008df3;
  border-radius: 6px;
  letter-spacing: 0.1px;
  font-weight: 600;
  font-size: 20px;
  color: #fff;
}
//******//
//******//
//******//
.ly_alert {
  width: 540px;
  padding: 65px 58px 60px;
}
.ly_alert .ly_inner {
  padding: 0 !important;
  text-align: center;
  background-color: #f0f5fa !important;
}
.ly_alert .ly_inner strong {
  display: block;
  font-size: 17px;
}
.ly_alert .ly_inner .btnWrap {
  display: flex;
  justify-content: center;
  .box_btn {
    width: 50%;
    height: 56px;
    &.wt {
      margin-right: 10px;
    }
    .an_t {
      font-size: 18px;
      line-height: 56px;
    }
  }
}

.box_wrap .box + .box {
  position: relative;
  padding: 40px 56px 0px 56px;
  margin-top: 40px;
  border-top: 1px solid #d6e7f1;
}

.form_wrap > li + li {
  margin-top: 20px;
}
@media (max-width: 1024px) {
  .box_wrap {
    padding: 48px 0px !important;
    border-radius: 20px;
  }
}
@media (max-width: 768px) {
  .apply_formlist {
    .form_wrap {
      li {
        flex-direction: column;
        align-items: flex-start;
        p {
          margin-bottom: 1rem;
        }
        + .mt_12 {
          margin-top: 8px;
          color: $h_BLUE_01;
        }
        .box_btn {
          white-space: nowrap;
          height: 100%;
          color: $white;
          padding: 11px 26px 14px;
        }
        input,
        .btn_wrap {
          flex: 1;
          width: 100%;
        }
      }
    }
  }
  .ly_alert {
    .ly_inner {
      p {
        font-size: 22px;
      }
      .btnWrap {
        .box_btn {
          padding: 0px 40px;
          height: 60px;
          .an_t {
            line-height: 60px;
            font-size: 20px;
          }
        }
        .box_btn.wt {
          margin-right: 0px;
          margin-bottom: 10px;
        }
      }
    }
  }
}
@media (max-width: 526px) {
  .apply_formlist .form_wrap .before_wrap p {
    position: static;
    min-height: 48px;
    transform: translateY(-5%);
  }
  .before_wrap {
    padding: 0 !important;
    .input_t_wrap {
      width: 100%;
    }
  }
}
</style>
